import { render, staticRenderFns } from "./PlusHeaderConfirmation.vue?vue&type=template&id=e05459e6"
import script from "./PlusHeaderConfirmation.vue?vue&type=script&lang=js"
export * from "./PlusHeaderConfirmation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports